import React, { useState } from "react";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import PopupNotiInfo from "../../components/pages/Manage/Popup/PopupNotiInfo";
import PopupTab from "../../components/pages/Manage/Popup/PopupTab";
import PopupTemplate from "../../components/pages/Manage/Popup/PopupTemplate";

export default function Popup() {
  const [tab, setTab] = useState(0);

  return (
    <>
      <PageTitle title="팝업 관리" />

      <PopupTab tab={tab} setTab={setTab} />

      {tab === 0 ? <PopupNotiInfo /> : <PopupTemplate />}
    </>
  );
}
